import Skeleton from "@mui/material/Skeleton";
import {
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table,
    TableBody,
    Checkbox,
} from "@mui/material";
import {
    styleContainerList,
    styleListingOutLine,
    styleTableCellHeader,
} from "../../../utils/common_style_for_list";
import CommonColorUtils from "../../../utils/common_colors";
import No_Record_Found_Page from "../task_allocation/no_record_found_page";
import mpsIcon from "../../../assets/mps_icon.svg";
import {

    localDateFormatWithMonthNameInShort,
    localTimeFormat
} from "../../../utils/date_time_convert_utils";
import {replaceHyphenBlankString} from "../../../components/string_utils";
import divider from "../../../assets/images/line.png";
import StringUtils from "../../../utils/string_utils";


const RtoOrderPage = ({isBusy, fmOrderList, selectedCpAwbs, setSelectedCpAwbs, isAllChecked, setIsAllChecked}) => {

    const columns = [
        {id: "orderId", label: StringUtils.orderId, width: "210px"},
        {id: "awb", label: StringUtils.awb, width: "210px"},
        {id: "pickupInfoName", label: StringUtils.pickupLocation, width: "180px"},
        {id: "direction", label: StringUtils.direction, width: "100px"},
        {id: "assetId", label: StringUtils.assetId, width: "100px"},
        {id: "boxCount", label: StringUtils.numberOfBoxes, width: "60px"},
        {id: "concept", label: StringUtils.concept.toUpperCase(), width: "120px"},
        {id: "vendorLocation", label: StringUtils.vendorName, width: "150px"},
        {id: "contactNumber", label: StringUtils.contactNo, width: "120px"},
        {id: "city", label: StringUtils.city, width: "100px"},
        {id: "area", label: StringUtils.area, width: "100px"},
        {id: "address", label: StringUtils.address, width: "150px"},
        {id: "orderBookedAt", label: StringUtils.orderBookedAt.toUpperCase(), width: "180px"},
    ];


    const handleSelectAllCheckbox = () => {
        if (isAllChecked) {
            setSelectedCpAwbs([]); // Deselect all
        } else {
            const allCpAwbs = fmOrderList.map((row) => row.awb);
            setSelectedCpAwbs([]);
            setSelectedCpAwbs(allCpAwbs); // Select all rows
        }
        setIsAllChecked(!isAllChecked);
    };

    const handleEachCellCheckbox = (cpAwb) => {
        setSelectedCpAwbs((prevSelected) => {
            let updatedSelected;
            if (prevSelected.includes(cpAwb)) {
                /// Deselect the selected rowId
                updatedSelected = prevSelected.filter((id) => id !== cpAwb);
            } else {
                ///  selected the rowId
                updatedSelected = [...prevSelected, cpAwb];
            }

            // Update the "select all" checkbox state
            setIsAllChecked(updatedSelected.length === fmOrderList.length);
            return updatedSelected;
        });
    };

    const renderCell = (column, row) => {
        const cellStyle = {
            display: "flex",
            flexDirection: "column",
            alignItems: "left",
            width: `${column.width}`,
            whiteSpace: "normal",
            wordWrap: "break-word",
            overflowWrap: "break-word", // Add ellipsis for overflowed text
            paddingLeft: (column.id === "orderId" && !row.isMps) ? "10px" : "0px",
        };
        if (column.id === "orderId") {
            return (<div style={{display: "flex", alignItems: "center"}}>
                {row.isMps && <img src={mpsIcon}/>}
                <span
                    style={{...cellStyle}}
                >
                    {replaceHyphenBlankString(row[column.id])}

                </span>

                <img src={divider} alt="vertical-line" style={{
                    position: "absolute",
                    right: 0,
                    top: 0,
                    width: "10px",
                    height: "100%",
                    opacity: "20%",
                    zIndex: 3
                }}/>
            </div>)
        } else if (column.id === "orderBookedAt") {
            return <div style={{...cellStyle}}>
                {`${localDateFormatWithMonthNameInShort(row[column.id])} at ${localTimeFormat(row[column.id])}`}

            </div>;
        } else {
            return (<span
                style={{...cellStyle}}
            >
                 {replaceHyphenBlankString(row[column.id])}

        </span>)
        }
    }


    return (
        <>
            <div style={{
                ...styleListingOutLine, marginTop: "3px",...(!localStorage.getItem('isFromHostApplication') ?{height: 'calc(86vh - 160px)'}:{height: 'calc(80vh - 160px)'})
            }}>
                {!isBusy && fmOrderList.length === 0 ? (
                    <No_Record_Found_Page/>
                ) : (
                    <>
                        {isBusy ? (
                            <>
                                {Array.from({length: 20}).map((_, index) => (
                                    <div key={index}>
                                        <Skeleton
                                            variant="rectangular"
                                            width={"100%"}
                                            height={80}
                                            style={{
                                                marginBottom: "8px",
                                                flex: 1,
                                                overflowX: "auto",
                                            }}
                                        />
                                    </div>
                                ))}
                            </>
                        ) : (
                            <>
                                <TableContainer style={styleContainerList}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>

                                                <TableCell
                                                    style={{
                                                        ...styleTableCellHeader,
                                                        left: 0,
                                                        zIndex: 3,
                                                        padding: "0px",
                                                        width: "10px"
                                                    }}
                                                >
                                                    <Checkbox
                                                        indeterminate={selectedCpAwbs.length > 0 && selectedCpAwbs.length < fmOrderList.length}
                                                        checked={isAllChecked}
                                                        onChange={handleSelectAllCheckbox}/>
                                                </TableCell>

                                                {columns.map((column, index) => (
                                                    <TableCell
                                                        key={index}
                                                        align={"left"}
                                                        style={{
                                                            ...styleTableCellHeader,
                                                            left: column.id === "orderId" ? "70px" : "auto",
                                                            zIndex: column.id === "orderId" ? 3 : 1,
                                                            width: column.width,
                                                            paddingLeft: column.id === "orderId" ? "20px" : "10px",
                                                        }}
                                                    >
                                                        {column.id === "orderId" &&
                                                            <img src={divider} alt="vertical-line" style={{
                                                                position: "absolute",
                                                                right: 0,
                                                                top: 0,
                                                                width: "10px",
                                                                height: "100%",
                                                                opacity: "20%",
                                                                zIndex: 3
                                                            }}/>}
                                                        {column.label}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {fmOrderList.map((row, rowIndex) => (
                                                <TableRow
                                                    key={rowIndex}

                                                >

                                                    <TableCell
                                                        style={{
                                                            height: "53px",
                                                            backgroundColor: selectedCpAwbs.includes(row.awb) ? CommonColorUtils.kSelectedBackgroundColor : CommonColorUtils.kPrimaryPureWhite,
                                                            fontFamily: "Inter, Arial, sans-serif",
                                                            // color: "#6F727A",
                                                            fontWeight: "600",
                                                            fontSize: "12px",
                                                            position: "sticky",
                                                            left: 0,
                                                            zIndex: 1,
                                                            padding: "0px",
                                                            paddingLeft: "10px",
                                                            width: "10px",
                                                        }}
                                                    >
                                                        <Checkbox
                                                            checked={selectedCpAwbs.includes(row.awb)}
                                                            onChange={() => handleEachCellCheckbox(row.awb)}
                                                        />
                                                    </TableCell>

                                                    {columns.map((column, columnIndex) => (
                                                        <TableCell
                                                            key={`${rowIndex}-${columnIndex}`}
                                                            align={"left"}
                                                            style={{
                                                                backgroundColor: selectedCpAwbs.includes(row.awb) ? CommonColorUtils.kSelectedBackgroundColor : CommonColorUtils.kPrimaryPureWhite,
                                                                padding: "0px",
                                                                paddingLeft: "10px",
                                                                paddingRight: "20px",
                                                                height: "53px",
                                                                borderBottom: `1px solid ${CommonColorUtils.primaryGrey300}`,
                                                                width: column.width,
                                                                fontFamily: "Inter, Arial, sans-serif",
                                                                color: column.id === "orderId" ? CommonColorUtils.primaryMainBlue : CommonColorUtils.primaryGrey700,
                                                                fontWeight:
                                                                    column.id === "orderId"
                                                                        ? 600
                                                                        : 400,
                                                                fontSize: "14px",
                                                                position:
                                                                    column.id === "orderId" ? "sticky" : "static",
                                                                left: column.id === "orderId" ? "70px" : "auto",
                                                                zIndex: column.id === "orderId" ? 2 : 1,

                                                            }}
                                                        >
                                                            {renderCell(column, row)}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                            </>
                        )}
                    </>
                )}
            </div>
        </>
    );
};

export default RtoOrderPage;
